import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, Mail, ArrowLeft, CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import axios from "axios";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_propmatch-7/artifacts/y6a3qiy4_LogotipoFinal_IkonicDeals%28web%29.jpg";
const API = process.env.REACT_APP_BACKEND_URL;

const ForgotPasswordPage = () => {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(`${API}/api/auth/forgot-password`, { email });
      setSubmitted(true);
    } catch (error) {
      // Always show success to prevent email enumeration
      setSubmitted(true);
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center p-4" data-testid="forgot-password-page">
        <div className="w-full max-w-md text-center">
          <img src={LOGO_URL} alt="Ikonic Deals" className="h-16 mx-auto mb-8" />
          
          <div className="bg-[#121212] border border-white/5 p-8">
            <CheckCircle className="w-16 h-16 text-[#D4AF37] mx-auto mb-6" />
            <h1 className="text-2xl text-white mb-4">Revisa tu correo</h1>
            <p className="text-[#A3A3A3] mb-6">
              Si existe una cuenta asociada a <span className="text-white">{email}</span>, 
              recibirás un enlace para restablecer tu contraseña.
            </p>
            <p className="text-[#525252] text-sm mb-8">
              El enlace expira en 1 hora. Si no recibes el correo, revisa tu carpeta de spam.
            </p>
            
            <Link 
              to="/panel-gestion-8k2m/acceso"
              className="inline-flex items-center gap-2 text-[#A3A3A3] hover:text-[#D4AF37] transition-colors"
              data-testid="back-to-login"
            >
              <ArrowLeft size={18} />
              Volver al inicio de sesión
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center p-4" data-testid="forgot-password-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src={LOGO_URL} alt="Ikonic Deals" className="h-16 mx-auto mb-6" />
          <h1 className="text-2xl text-white">Recuperar contraseña</h1>
          <p className="text-[#A3A3A3] mt-2">
            Ingresa tu correo electrónico y te enviaremos instrucciones
          </p>
        </div>

        <form onSubmit={handleSubmit} className="bg-[#121212] border border-white/5 p-8 space-y-6">
          <div>
            <label className="block text-sm text-[#A3A3A3] mb-2">Email</label>
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 text-white/40" size={18} />
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="tu@email.com"
                className="h-12 bg-black/40 border-white/10 text-white placeholder:text-white/40 pl-10"
                data-testid="forgot-email"
                required
              />
            </div>
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="w-full h-12 bg-[#D4AF37] text-black hover:bg-[#FFE082] font-medium"
            data-testid="forgot-submit"
          >
            {loading ? <Loader2 className="animate-spin" size={20} /> : "Enviar instrucciones"}
          </Button>
        </form>

        <p className="text-center mt-6 text-[#525252] text-sm">
          <Link 
            to="/panel-gestion-8k2m/acceso" 
            className="hover:text-[#D4AF37] transition-colors inline-flex items-center gap-2"
          >
            <ArrowLeft size={16} />
            Volver al inicio de sesión
          </Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
